import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { AlertService } from "../_services/index";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { EncryptionService } from "../_services/encryption.service";
import { OnboardOrganizationService } from "../_services/onboard-organization.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

@Component({
  selector: "app-onboard-organization",
  templateUrl: "./onboard-organization.component.html",
})
export class OnboardOrganizationComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  filterData = { approve_status: "ALL" };

  dtTrigger = new Subject();
  onboardOrgList: any[] = [];
  totalOnboardOrganization: any;
  closeResult: string;
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    serverSide: true,
    processing: true,
    order: [[10, "desc"]],
  };
  showloding = true;
  lodingImage = false;
  start: number = 0;
  pageLength: number = 10;
  constructor(
    public router: Router,
    private alertService: AlertService,
    private modalService: NgbModal,
    private http: HttpClient,
    private enc_dec: EncryptionService,
    private dataService: OnboardOrganizationService,
  ) {}

  modalReference: NgbActiveModal;
  modalTitle: string;

  ngOnInit() {
    window.scroll(0, 0);
       if (localStorage.getItem("organization_approve_status") != null) {
      this.filterData.approve_status = localStorage.getItem("organization_approve_status");
    }

    this.loadHide();
    this.getAllOnboardList();
  }

  getAllOnboardList() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      order: [[10, "desc"]],
      columnDefs: [{ orderable: false, targets: [0, 1, 6, 7, 8] }],
      ajax: (dataTablesParameters: any, callback) => {
        this.start = dataTablesParameters.start;
        this.pageLength = dataTablesParameters.length;

        this.http
          .post<DataTablesResponse>(
            "/api/service-provider-list",
            {
              req_data: this.enc_dec.encrypt(
                JSON.stringify(
                  Object.assign(dataTablesParameters, this.filterData)
                )
              ),
            },
            {},
          )
          .subscribe((response: any) => {            
            const output = this.enc_dec.decrypt(response.res_data);
            var resp = JSON.parse(output);
            this.onboardOrgList = resp["data"];
            this.totalOnboardOrganization = resp["recordsFiltered"];
            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [
        { data: null },
        { data: null },
        { data: "approve_status" },
        { data: "status" },
        { data: "approved_rejected_date" },
        { data: "name" },
        { data: "type_relation.name" },
        { data: "state_relation.state_name" },
        { data: "district_relation.city_name" },
        { data: "created_at" },
        { data: "updated_at" },
      ],
    };
  }

  getRowNumber(index: number): number {
    return this.start + index + 1;
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  onOnboardView(id) {
    this.router.navigate(["onboard-organization-view/" + id]);
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  setFilterData(e: any) {
    this.filterData.approve_status = e.target.value;
    localStorage.setItem("organization_approve_status", this.filterData.approve_status);
    const table = $("#onboard_org").DataTable();
    table.ajax.reload(null, true);
  }

  delete(item) {
    const data = {
      id: item.id,
    };
    this.loadShow();
    this.dataService
      .updateStatus(data)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success("Partner deleted successfully", true);
            item.status = item.status == "1" ? "0" : "1";
          } else {
            this.alertService.error("Partner error");
          }
        },
        (error) => {
          this.alertService.error(error);
        },
      );
    this.loadHide();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
